import { PureComponent } from 'react';

import { uncurlyUuid } from '@atlassian/bitkit-analytics';

import { Repository } from 'src/components/types';
import RefSelector from 'src/sections/repository/components/ref-selector';
import * as styles from 'src/sections/repository/components/ref-selector/ref-selector.style';
import { Ref } from 'src/sections/repository/types';
import urls from 'src/urls/source';
import { publishUiEvent } from 'src/utils/analytics/publish';

type Props = {
  currentRef?: Ref;
  path?: string;
  repository?: Repository;
};

export default class SourceBrowserRefSelector extends PureComponent<Props> {
  refUrl = (ref: Ref, repository: Repository): string => {
    const { path } = this.props;
    return urls.ui.sourceWithRef(repository.full_name, ref, { path });
  };

  handleOpen = () => {
    const { repository } = this.props;

    if (repository) {
      publishUiEvent({
        source: 'file',
        action: 'clicked',
        actionSubject: 'dropdown',
        actionSubjectId: 'refSelector',
        objectType: 'repository',
        objectId: uncurlyUuid(repository.uuid),
        containerType: 'workspace',
        containerId: repository?.workspace
          ? uncurlyUuid(repository.workspace.uuid)
          : '',
        attributes: {
          label: 'branches',
          repository_uuid: uncurlyUuid(repository.uuid),
          frontbucket_view: true,
        },
      });
    }
  };

  render() {
    const { currentRef, repository } = this.props;

    if (!repository) {
      return null;
    }

    return (
      <RefSelector
        label={currentRef ? currentRef.name : undefined}
        onOpen={this.handleOpen}
        renderRef={ref => {
          if (!repository) {
            return null;
          }

          return (
            <styles.RefLink
              onClick={() => {
                publishUiEvent({
                  source: 'refSelector',
                  action: 'clicked',
                  actionSubject: 'link',
                  actionSubjectId: 'refLink',
                  objectType: 'repository',
                  objectId: uncurlyUuid(repository.uuid),
                  containerType: 'workspace',
                  containerId: repository?.workspace
                    ? uncurlyUuid(repository.workspace.uuid)
                    : '',
                  attributes: {
                    label: 'branch_selected',
                    repository_uuid: uncurlyUuid(repository.uuid),
                    frontbucket_view: true,
                  },
                });
              }}
              href={this.refUrl(ref, repository)}
            >
              {ref.name}
            </styles.RefLink>
          );
        }}
        repository={repository}
      />
    );
  }
}
